import React, { useState } from 'react'

function ModalFilterComponent(props) {
    const [data, setData] = useState("")
    // void 0
    return (

        <div className="content mt-4 ml-4 ">
            <form className="comment-form">
                <div className="row">

                    <div className="col-lg-6">
                        <div className="form-group">
                            <label className="text-black font-w600">Name <span className="required"></span></label>
                            <input type="text" className="form-control" name="name" placeholder="Search" value={data}
                                onChange={(e) => {
                                    setData(e.target.value);
                                    var x = e.target.value
                                    // props.searchFunction(x)
                                }}
                            />
                        </div>
                    </div>
                    <div className="col-lg-6 mt-4">
                        <div className="row mt-1">
                            <div className="col">
                                <button className="btn btn-sm btn-primary" onClick={(e) => {
                                    e.preventDefault()
                                    setData("")
                                    // props.searchFunction("")
                                }}>Clear</button>
                            </div>
                            <div className="col">
                                <button className="btn btn-sm btn-primary" onClick={(e) => {
                                    e.preventDefault()
                                    // setData("")
                                    props.searchFunction(data)
                                }}>Search</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div >

    )
}

export default ModalFilterComponent
